import axios from "axios"
import * as actionType from "../actions/actionTypes"
import _ from "lodash"
import moment from "moment"
export const loadingStart = () => {
  return {
    type: actionType.LOADING_START,
  }
}
export const requestSuccess = (data = {}) => {
  return {
    type: actionType.REQUEST_SUCCESS,
    payload: data,
  }
}

export const requestFail = () => {
  return {
    type: actionType.REQUEST_FAIL,
  }
}

export const eduProfileUpdate = () => {
  return {
    type: actionType.EDU_PROFILE_UPDATED,
    payload: Date.now(),
    formEditOpen: false,
    formDeleteOpen: false,
  }
}
export const eduProfileRefresh = () => {
  return {
    type: actionType.EDU_PROFILE_REFRESH,
    payload: Date.now(),
  }
}
export const editDegreeDetail = uuid => {
  return {
    type: actionType.EDIT_DEGREE_UUID,
    payload: uuid,
  }
}
export const formDeleteOpen = value => {
  return {
    type: actionType.FORM_DELETE_OPEN,
    payload: value,
  }
}
export const formEditOpen = value => {
  return {
    type: actionType.FORM_EDIT_OPEN,
    payload: value,
  }
}

export const eventsContent = data => {
  return {
    type: actionType.EVENTS_CONTENT,
    payload: data,
  }
}
export const newsContent = data => {
  return {
    type: actionType.NEWS_CONTENT,
    payload: data,
  }
}
export const fetchContentType = type => {
  return dispatch => {
    dispatch(loadingStart())
    axios
      .get(actionType.API_PATH + "/" + type)
      .then(response => {
        dispatch(requestSuccess(response.data))
      })
      .catch(err => {
        dispatch(requestFail())
        console.log(err)
      })
  }
}

export const fetchEducationDetais = user_uuid => {
  return dispatch => {
    dispatch(loadingStart())
    axios
      .get(
        actionType.API_PATH +
          "/" +
          "academicDetail?filter[academicUser][condition][path]=academicUser.id&filter[academicUser][condition][value]=" +
          user_uuid
      )
      .then(response => {
        dispatch(eduProfileRefresh())
        setEducationDetais(response.data.data)
        dispatch(requestSuccess({}))
      })
      .catch(err => {
        dispatch(requestFail())
        console.log(err)
      })
  }
}

/**
 * Local Store user data
 */
export const setEducationDetais = eduDetailsObject => {
  if (eduDetailsObject) {
    localStorage.setItem("eduDetailsObject", JSON.stringify(eduDetailsObject))
  } else {
    localStorage.removeItem("eduDetailsObject")
  }
}

/**
 * Local Store user data
 */
export const getEducationDetail = () => {
  const eduDetailsObject = window.localStorage.getItem("eduDetailsObject")
  return eduDetailsObject ? JSON.parse(eduDetailsObject) : null
}

/**
 * Local Store user data
 */
export const getDegreeDetail = (uuid = "") => {
  const eduDetailsObject = window.localStorage.getItem("eduDetailsObject")
  const eduDetailsData = eduDetailsObject ? JSON.parse(eduDetailsObject) : null
  const Details = _.filter(eduDetailsData, { id: uuid })
  const info = _.get(Details, "0.attributes")
  return {
    DegreeTitle:
      info && info["AcademicDegreeTitle"] ? info["AcademicDegreeTitle"] : "",
    CollegeName:
      info && info["academicCollegeName"] ? info["academicCollegeName"] : "",
    StartYear:
      info && info["academicStartYear"]
        ? moment(info["academicStartYear"]).format("YYYY")
        : "none",
    EndYear:
      info && info["academicEndYear"]
        ? moment(info["academicEndYear"]).format("YYYY")
        : "none",
    Country: info && info["academicCountry"] ? info["academicCountry"] : "none",
  }
}
/**
 *
 * @param {*} contentType Content Type name
 * @param {*} contentObject Node object ( content Data)
 * @param {*} uid_uuid user UUID
 * @function create new node
 */
export const contentCreate = (
  contentType,
  contentObject = {},
  uid_uuid = ""
) => {
  return dispatch => {
    dispatch(loadingStart())
    const axiosPostConfig = {
      headers: axios.defaults.headers.post,
    }
    axios
      .post(
        actionType.API_PATH + "/" + contentType,
        contentObject,
        axiosPostConfig
      )
      .then(responce => {
        dispatch(eduProfileUpdate())
        dispatch(requestSuccess({}))
      })
      .catch(err => {
        console.log("TCL: userUpdate -> err", err)
        dispatch(requestFail("not update error"))
        // console.log(errorResponse)
      })
  }
}
/**
 *
 * @param {*} contentType Content Type name
 * @param {*} contentObject Node object ( content Data)
 * @param {*} uid_uuid user UUID
 * @param {*} content_uuid node uuid
 * @ node
 */
export const contentUpdate = (
  contentType,
  contentObject = {},
  content_uuid
) => {
  return dispatch => {
    dispatch(loadingStart())
    const axiosPostConfig = {
      headers: axios.defaults.headers.patch,
    }
    axios
      .patch(
        actionType.API_PATH + "/" + contentType + "/" + content_uuid,
        contentObject,
        axiosPostConfig
      )
      .then(responce => {
        dispatch(eduProfileUpdate())
        dispatch(requestSuccess({}))
      })
      .catch(err => {
        console.log("TCL: userUpdate -> err", err)
        dispatch(requestFail("not update error"))
        // console.log(errorResponse)
      })
  }
}

/**
 * @function delete node
 * @param {*} contentType Content Type name
 * @param {*} content_uuid node uuid
 */
export const contentDelete = (contentType, content_uuid) => {
  return dispatch => {
    dispatch(loadingStart())
    const axiosPostConfig = {
      headers: axios.defaults.headers.patch,
    }
    axios
      .delete(
        actionType.API_PATH + "/" + contentType + "/" + content_uuid,
        axiosPostConfig
      )
      .then(responce => {
        dispatch(eduProfileUpdate())
        dispatch(requestSuccess({}))
      })
      .catch(err => {
        console.log("TCL: userUpdate -> err", err)
        dispatch(requestFail("not update error"))
        // console.log(errorResponse)
      })
  }
}
export const fetchXMLHttpRequest = (type = "index") => {
  return dispatch => {
    var createCORSRequest = function(method, url) {
      dispatch(loadingStart())
      var xhr = new XMLHttpRequest()
      if ("withCredentials" in xhr) {
        // Most browsers.
        xhr.open(method, url, true)
      } else if (typeof XDomainRequest != "undefined") {
        // IE8 & IE9
        xhr = new XDomainRequest()
        xhr.open(method, url)
      } else {
        // CORS not supported.
        xhr = null
      }
      return xhr
    }

    var url =
      actionType.HBKU_WEB +
      "/en/api/data.json?type=" +
      type +
      "&parameters[language]=en&pagesize=10"
    var method = "GET"
    var xhr = createCORSRequest(method, url)

    xhr.onload = function() {
      // var str = xhr.responseText
      var data = JSON.parse(xhr.responseText)
      if (type === "news") {
        dispatch(newsContent(data))
      }
      if (type === "events") {
        dispatch(eventsContent(data))
      }
      dispatch(requestSuccess({}))
      // Success code goes here.
    }

    xhr.onerror = function() {
      dispatch(requestFail("error:fetching date from hbku"))
    }

    xhr.send()
  }
}
export const fetchDataFromHBKU = (type = "index") => {
  return dispatch => {
    dispatch(loadingStart())
    /// axios.defaults.headers.get["Content-Type"] = "application/json"
    // axios.defaults.headers.get["Accept"] = "application/json"
    axios.defaults.headers.get["X-Requested-With"] = "XMLHttpRequest"
    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*"
    //   "http://localhost:8000"
    const axiosGetConfig = {
      headers: axios.defaults.headers,
    }
    console.log("TCL: fetchDataFromHBKU -> axiosGetConfig", axiosGetConfig)
    axios
      .get(
        actionType.HBKU_WEB +
          "/en/api/data.json?type=news&parameters[language]=en",
        axiosGetConfig
      )
      .then(response => {
        console.log("TCL: response", response)
        //  dispatch(eduProfileRefresh())
        //setEducationDetais(response.data.data)
        // return response.data.data
        dispatch(requestSuccess({}))
      })
      .catch(err => {
        dispatch(requestFail())
        console.log(err)
      })
  }
}
